import React, { useEffect, useRef, useState } from "react";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,

    Typography,
    Box,
} from "@mui/material";
import { styled } from '@mui/material/styles';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from '../../../component/addCategoryForm/addCategoryForm.module.css';

import NestedUserHeader from "../../../component/reusable/NestedUserHeader";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { useDispatch, useSelector } from "react-redux";

import PopularProd from "../product/PopularProd";
import Categories from "../Categories";
import { getHeroBannerThunk, heroBannerThunk } from "../../../redux/appearanceSlice";
import { getCategoryHeirarchy } from "../../../redux/getCategoryHeirarchy";
import SliderView from "./SliderView";
import CategoryView from "./CategoryView";
import PopProductView from "../product/PopProductView";
import FeaturedBrandView from "../FeaturedBrandView";


const Accordions = styled(Accordion)(({ theme }) => ({
    borderRadius: '8px !important',
    boxShadow: 'none',
    border: `1px solid ${theme.palette.divider}`,
    margin: "20px 0px",
    fontFamily: `'Public Sans', sans-serif`,
    '&::before': {
        background: 'transparent',
        content: 'none',
    },
}));


const ViewAppearences = () => {
    const [expanded, setExpanded] = useState(false);
    const dispatch = useDispatch()


    const { heroBannerData } = useSelector((state) => state.appearances)

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const isImage = (url) => /\.(jpg|jpeg|png|gif|webp)$/i.test(url);
    const isVideo = (url) => /\.(mp4|mov|avi|webm)$/i.test(url);

    // General Information Formik
    const heroBannerFormic = useFormik({
        initialValues: {
            bannerTitle: heroBannerData?.data?.bannerTitle || '',
            bannerImage: heroBannerData?.data?.assets?.url || '',
        },
        enableReinitialize: true,

        onSubmit: async (values) => {

        },
    });





    useEffect(() => {
        dispatch(getHeroBannerThunk())
        dispatch(getCategoryHeirarchy());
    }, [])


    return (
        <>

            <NestedUserHeader
                index="Home Page Builder"
                root="Dashboard"
                buttonText={'Back to list'} />
            <Box sx={{ width: '85%', }}>
                {/* Hero Banner Section */}
                <Accordions sx={{ marginBottom: "20px" }}
                    expanded={expanded === "panel1"}
                    onChange={handleChange("panel1")}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography sx={{
                            fontSize: "16px",
                            color: "#1D1F2C",
                        }}>Hero Banner</Typography>
                    </AccordionSummary>

                    <AccordionDetails sx={{ background: '#F0F1F3B2', margin: "0px 20px 20px 20px" }}>
                        <form >
                            <label className={styles.addCatLabel} >
                                Banner Title
                                <input
                                    type="text"
                                    name="bannerTitle"
                                    placeholder="Enter "
                                    className={styles.addCatInput}

                                    value={heroBannerFormic.values.bannerTitle}
                                    disabled={true}
                                    style={{ background: 'white' }}
                                />

                            </label>



                            <div className={styles.imageUpload}>

                                <p className={styles.addCatLabel}>Banner Image</p>


                                <div className={styles.uploadBox} style={{ background: '#fff', display: 'flex', justifyContent: 'center' }}>
                                    {isImage(heroBannerFormic.values.bannerImage) &&
                                        <img src={heroBannerFormic.values.bannerImage} alt="" className={styles.previewImage} />
                                    }
                                    {isVideo(heroBannerFormic.values.bannerImage) &&
                                        <video
                                            controls
                                            style={{ width: '100%', maxHeight: '500px' }}
                                            className={styles.previewImage}
                                        >
                                            <source src={heroBannerFormic.values.bannerImage} type="video/mp4" />
                                        </video>
                                    }

                                </div>

                            </div>


                        </form>
                    </AccordionDetails>
                </Accordions>

                {/* Sliders Section */}
                <SliderView
                    Accordions={Accordions}
                    handleChange={handleChange}
                    expanded={expanded}
                    isImage={isImage}
                    isVideo={isVideo}
                />


                <CategoryView
                    Accordions={Accordions}
                    handleChange={handleChange}
                    expanded={expanded}
                />

                <FeaturedBrandView
                    Accordions={Accordions}
                    handleChange={handleChange}
                    expanded={expanded}
                />



                {/* Product/Manufacturer */}
                <PopProductView
                    Accordions={Accordions}
                    handleChange={handleChange}
                    expanded={expanded}
                />


            </Box>
        </>
    );
};

export default ViewAppearences;
